import { CANCEL_WAIT_LOGIN, LOGIN_SUCCESS } from '../actions/AuthActions/constants';

export const waitForLogin = (store) => (next) => (action) => {
  if (action.type === LOGIN_SUCCESS) {
    // Resolve the promise when LOGIN_SUCCESS is dispatched
    store.dispatch({ type: CANCEL_WAIT_LOGIN });
  }

  return next(action);
};
